/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:55:16
 * @LastEditTime: 2023-03-02 18:03:36
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-statistic-analy\modules\summaryFlowStatisRouter.js
 * 汇总流向统计
 */
import store from '@/store'
import { getAuthClientList } from '@/api/common'
const summaryFlowStatisRouter = [
  // 纯销明细表
  {
    path: '/flowSystem/summary/sales-details',
    name: 'flowSystemSummarySalesDetails',
    component: () => 
    // import('../views/flowSystem/summary/SalesDetails.vue')
    import('@/views/butterfly-flow-system/flow-direction-statistic-analy/summary-flow-statis/pure-parts-list/Page.vue'),
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 5, 6, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
    meta: {
      SecondaryMenu: '汇总流向统计', //二级菜单
      title: '纯销明细表',
    },
  },
]
export default summaryFlowStatisRouter
